import { useNavigate } from '@tanstack/react-router'
import { Compass, Home } from 'lucide-react'
import { Button } from '@/components/ui'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 'var(--space-16) var(--gutter)',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/assets/zellij-tile.svg')",
          backgroundSize: '130px 130px',
          opacity: 0.16,
        }}
      />
      <div style={{ position: 'relative', maxWidth: 560 }}>
        <div style={{ position: 'relative', height: 200, marginBottom: 8 }}>
          <img
            src="/assets/oumma-mark-gold.svg"
            alt=""
            className="oumma-404-star"
            width="120"
            height="120"
          />
          <img
            src="/assets/oumma-mark.svg"
            alt=""
            className="oumma-404-shard s1"
            width="34"
            height="34"
          />
          <img
            src="/assets/oumma-mark.svg"
            alt=""
            className="oumma-404-shard s2"
            width="22"
            height="22"
          />
          <img
            src="/assets/oumma-mark.svg"
            alt=""
            className="oumma-404-shard s3"
            width="28"
            height="28"
          />
        </div>
        <div
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 15,
            fontWeight: 600,
            letterSpacing: '0.3em',
            color: 'var(--gold-700)',
            marginBottom: 14,
          }}
        >
          4 · 0 · 4
        </div>
        <h1 style={{ fontSize: 'var(--text-h1)', margin: '0 0 14px' }}>
          Oups ! Il n'y a rien au bout de ce chemin.
        </h1>
        <p
          style={{
            fontSize: 'var(--text-lead)',
            color: 'var(--ink-2)',
            maxWidth: 440,
            margin: '0 auto 30px',
          }}
        >
          La page que vous cherchez n'existe pas. Mais ne vous en faites pas —
          la communauté vous attend par ici.
        </p>
        <div
          style={{
            display: 'flex',
            gap: 12,
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Button
            variant="primary"
            size="lg"
            iconLeft={<Home size={18} />}
            onClick={() => navigate({ to: '/' })}
          >
            Retour à l'accueil
          </Button>
          <Button
            variant="secondary"
            size="lg"
            iconLeft={<Compass size={18} />}
            onClick={() => navigate({ to: '/events', search: {} })}
          >
            Explorer les événements
          </Button>
        </div>
      </div>
    </div>
  )
}
